module.exports = __webpack_public_path__ + "img/top-1.3f12165.png";